export default {
      id: "icon-pegman-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-pegman",
      toString: function () {
        return this.url;
      }
    }